<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/N2aczv/tc-custom/9781504049160.jpg?1734279934318" alt="This image is the cover for the book Plague Ship, Solar Queen"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Plague Ship, Solar Queen
      </h1>
      <p class="bookDescription body article font2">
        <b>The Solar Queen series continues with a riotous adventure in space and a battle against a deadly plague.</b><br/>  <br/> Apprentice cargo-master Dane Thorson and the crew of the <i>Solar Queen</i> travel to the new planet Sargol to trade with the Salariki, a strange race of cat-men, for the fabulous Koros stones. When an Inter-Solar trading ship tries to cut in on their trading rights, they’re forced, according to Salariki custom, to fight a duel with a representative of the I-S ship in order to keep face. The <i>Queen</i>’s Captain Jellico wins, but the I-S ship leaves with a threat of further action.<br/>  <br/> Then, the <i>Solar Queen</i> takes off for Earth and en route a strange illness strikes them. They suspect the I-S are responsible, but can’t prove anything. Outlawed as a plague ship, they’re to be destroyed on sight lest they infect civilized planets. Thorson, Jellico, and the rest of their Terran crew must find a cure for the plague and escape imminent destruction.<br/>  <br/> Plague Ship<i> is the 2nd book in the Solar Queen series, but you may enjoy reading the series in any order.</i><br/>  <br/><i>This ebook has been professionally proofread to ensure accuracy and readability on all devices.</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andre Norton
      </h2>
      
      <p class="authorDescription body article">&amp;lt;DIV&amp;gt;For well over a half century, Andre Norton was one of the most popular science fiction and fantasy authors in the world. With series such as Time Traders, Solar Queen, Forerunner, Beast Master, Crosstime, and Janus, as well as many standalone novels, her tales of adventure have drawn countless readers to science fiction. Her fantasy novels, including the bestselling Witch World series, her Magic series, and many other unrelated novels, have been popular with readers for decades. Lauded as a Grand Master by the Science Fiction Writers of America, she is the recipient of a Life Achievement Award from the World Fantasy Convention. An Ohio native, Norton lived for many years in Winter Park, Florida, and died in March 2005 at her home in Murfreesboro, Tennessee.&amp;lt;/DIV&amp;gt;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?25b66e4f